import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';

// Configure Axios base URL
axios.defaults.baseURL = process.env.REACT_APP_API_URL || 'https://devexam.doode.in'; // Make sure this matches your backend URL

const StudentRegister = () => {
  const [formData, setFormData] = useState({
    username: '',
    password: '',
    confirmPassword: '',
    email: '',
    fullName: '',
    admissionNo: '', // Changed from admissionNumber to admissionNo to match the model
    collegeName: '',
  });
  
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('error'); // 'error' or 'success'
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  // Check if viewport is mobile size
  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => {
      window.removeEventListener('resize', checkMobile);
    };
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    
    // Check if passwords match
    if (formData.password !== formData.confirmPassword) {
      setMessage('Passwords do not match');
      setMessageType('error');
      return;
    }
    
    // Check password strength (optional)
    if (formData.password.length < 6) {
      setMessage('Password must be at least 6 characters long');
      setMessageType('error');
      return;
    }
    
    try {
      // Create submission data object with all required fields
      const submissionData = {
        username: formData.username,
        password: formData.password,
        email: formData.email,
        fullName: formData.fullName,
        admissionNo: formData.admissionNo || "NA",
        collegeName: formData.collegeName || "NA",
        accountType: "portalCreated" // CRITICALLY IMPORTANT - explicitly setting accountType
      };
      
      console.log("Frontend - Submitting with accountType:", submissionData.accountType);
      
      // Send request to the correct API endpoint
      const res = await axios.post('/api/student/register', submissionData, {
        headers: {
          'Content-Type': 'application/json',
          // Add this to ensure no middleware is stripping out fields
          'X-Preserve-Fields': 'accountType'
        }
      });
      
      if (res.data && res.data.message === 'Student registered successfully') {
        setMessage('Registration successful! Redirecting to login...');
        setMessageType('success');
      
        // Redirect after a short delay
        setTimeout(() => {
          navigate('/student-login');
        }, 2000);
      } else {
        setMessage(res.data?.message || 'Registration failed. Please try again.');
        setMessageType('error');
      }
      
    } catch (err) {
      console.error('Registration error:', err);
      setMessage(err.response?.data?.message || 'Registration failed. Please try again.');
      setMessageType('error');
    }
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        height: '100vh',
      }}
    >
      {/* Left Image Section */}
      <div
        style={{
          flex: 1,
          display: isMobile ? 'none' : 'block',
          backgroundImage: 'url("../images/studentloginimg.jpg")',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      {/* Right Registration Section */}
      <div
        style={{
          flex: 1,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: '#f9fafb',
          padding: '40px',
          overflowY: 'auto',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: '450px',
            backgroundColor: '#fff',
            padding: '40px',
            borderRadius: '16px',
            boxShadow: '0 0 20px rgba(0, 0, 0, 0.08)',
          }}
        >
          <h2 style={{ textAlign: 'center', marginBottom: '24px', color: 'purple' }}>
            Student Registration
          </h2>
          {message && (
            <div
              style={{
                backgroundColor: messageType === 'error' ? '#fee2e2' : '#d1fae5',
                color: messageType === 'error' ? '#b91c1c' : '#065f46',
                padding: '10px',
                borderRadius: '8px',
                marginBottom: '16px',
                textAlign: 'center',
              }}
            >
              {message}
            </div>
          )}
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <input
              type="text"
              name="fullName"
              placeholder="Full Name"
              value={formData.fullName}
              onChange={handleChange}
              required
              style={{
                padding: '12px 16px',
                borderRadius: '12px',
                border: '1px solid #ccc',
                fontSize: '14px',
                outline: 'none',
                transition: '0.3s',
              }}
              onFocus={(e) => (e.target.style.boxShadow = '0 0 0 2px #60a5fa')}
              onBlur={(e) => (e.target.style.boxShadow = 'none')}
            />
            <input
              type="email"
              name="email"
              placeholder="Email Address"
              value={formData.email}
              onChange={handleChange}
              required
              style={{
                padding: '12px 16px',
                borderRadius: '12px',
                border: '1px solid #ccc',
                fontSize: '14px',
                outline: 'none',
                transition: '0.3s',
              }}
              onFocus={(e) => (e.target.style.boxShadow = '0 0 0 2px #60a5fa')}
              onBlur={(e) => (e.target.style.boxShadow = 'none')}
            />

            {/* Admission Number (optional but will default to "NA") */}
            <input
              type="text"
              name="admissionNo"
              placeholder="Admission Number (Optional)"
              value={formData.admissionNo}
              onChange={handleChange}
              style={{
                padding: '12px 16px',
                borderRadius: '12px',
                border: '1px solid #ccc',
                fontSize: '14px',
                outline: 'none',
                transition: '0.3s',
              }}
              onFocus={(e) => (e.target.style.boxShadow = '0 0 0 2px #60a5fa')}
              onBlur={(e) => (e.target.style.boxShadow = 'none')}
            />

            {/* College Name (optional but will default to "NA") */}
            <input
              type="text"
              name="collegeName"
              placeholder="College Name (Optional)"
              value={formData.collegeName}
              onChange={handleChange}
              style={{
                padding: '12px 16px',
                borderRadius: '12px',
                border: '1px solid #ccc',
                fontSize: '14px',
                outline: 'none',
                transition: '0.3s',
              }}
              onFocus={(e) => (e.target.style.boxShadow = '0 0 0 2px #60a5fa')}
              onBlur={(e) => (e.target.style.boxShadow = 'none')}
            />
            <input
              type="text"
              name="username"
              placeholder="Username"
              value={formData.username}
              onChange={handleChange}
              required
              style={{
                padding: '12px 16px',
                borderRadius: '12px',
                border: '1px solid #ccc',
                fontSize: '14px',
                outline: 'none',
                transition: '0.3s',
              }}
              onFocus={(e) => (e.target.style.boxShadow = '0 0 0 2px #60a5fa')}
              onBlur={(e) => (e.target.style.boxShadow = 'none')}
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              required
              style={{
                padding: '12px 16px',
                borderRadius: '12px',
                border: '1px solid #ccc',
                fontSize: '14px',
                outline: 'none',
                transition: '0.3s',
              }}
              onFocus={(e) => (e.target.style.boxShadow = '0 0 0 2px #60a5fa')}
              onBlur={(e) => (e.target.style.boxShadow = 'none')}
            />
            <input
              type="password"
              name="confirmPassword"
              placeholder="Confirm Password"
              value={formData.confirmPassword}
              onChange={handleChange}
              required
              style={{
                padding: '12px 16px',
                borderRadius: '12px',
                border: '1px solid #ccc',
                fontSize: '14px',
                outline: 'none',
                transition: '0.3s',
              }}
              onFocus={(e) => (e.target.style.boxShadow = '0 0 0 2px #60a5fa')}
              onBlur={(e) => (e.target.style.boxShadow = 'none')}
            />
            <button
              type="submit"
              style={{
                padding: '12px 24px',
                backgroundImage:
                  'linear-gradient(#fff, #fff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF)',
                backgroundOrigin: 'border-box',
                backgroundClip: 'padding-box, border-box',
                color: 'purple',
                fontWeight: 'bold',
                fontSize: '16px',
                border: '2px solid transparent',
                borderRadius: '30px',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                marginTop: '8px',
              }}
              onMouseOver={(e) => {
                e.target.style.transform = 'scale(1.03)';
              }}
              onMouseOut={(e) => {
                e.target.style.transform = 'scale(1)';
              }}
            >
              Register Account
            </button>

            <div style={{ textAlign: 'center', marginTop: '8px' }}>
              <span style={{ fontSize: '14px', color: 'purple' }}>Already have an account?</span>
            </div>
            <Link to="/student-login" style={{ textDecoration: 'none' }}>
              <button
                type="button"
                style={{
                  width: '100%',
                  padding: '12px',
                  backgroundImage:
                    'linear-gradient(#ffffff, #ffffff), linear-gradient(to right, #FFBBBB, #A8C1FF, #C5A8FF)',
                  backgroundOrigin: 'border-box',
                  backgroundClip: 'padding-box, border-box',
                  color: 'purple',
                  fontWeight: 'bold',
                  fontSize: '16px',
                  border: '2px solid transparent',
                  borderRadius: '30px',
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = 'scale(1.02)';
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = 'scale(1)';
                }}
              >
                Back to Login
              </button>
            </Link>
          </form>
        </div>
      </div>
    </div>
  );
};

export default StudentRegister;